import { API } from "../../../../utils/api";

export async function getPeriodAPI(modelType) {
  return (await API.get(`v2/lease/periods?modelType=${modelType}`)).data
}